export enum Consumer {
  EV_TAX_CREDIT = 'ev-tax-credit',
  GUIDE_TO_BUYING_EV = 'guide-to-buying-ev',
  VDP = 'vdp',
  SRP = 'srp',
  HOME = 'home',
  HOMEWEBVIEW = 'home-webview',
  SEM = 'sem',
  WHAT_TO_EXPECT = 'what-to-expect'
}
